<script>
export default {}
</script>

<style lang="scss">
@import '../embeddable.scss';
</style>
